import moment from 'moment-timezone';

const localTimezone = moment.tz.guess(true);

/***
 * utc에서 kst ( local time zone )으로 변환
 */
String.prototype.utcToKst = function (format = "YYYY-MM-DD HH:mm:ss") {
  let result = this;
  return moment(result).tz(localTimezone).format(format);
};

/***
 * kst ( local time zone ) 에서 utc로 변환
 */
String.prototype.kstToUtc = function (format = "YYYY-MM-DDTHH:mm:ss") {
  return moment.tz(this, localTimezone).utc().format(format);
};

/***
 * kst에서 unix타임 얻어내기
 */
String.prototype.unixTime = function () {
  let timeString = this;
  if (!timeString.includes('+') && !timeString.endsWith('+09:00')) {
    timeString = timeString + '+09:00';
  }

  return moment(timeString).unix();
};

/***
 * kst에서 local timezone로 변환
 */
String.prototype.kstToLtz = function (format = "YYYY-MM-DD HH:mm:ss") {
  let timeString = this;
  if (!timeString.includes('+') && !timeString.endsWith('+09:00')) {
    timeString = timeString + '+09:00';
  }

  return moment(timeString).tz(localTimezone).format(format);
};

/***
 * local timezone에서 kst로 변환
 */
String.prototype.ltzToKst = function (format = "YYYY-MM-DDTHH:mm:ss") {
  let timeString = this;
  return moment.tz(timeString, localTimezone).clone().tz("Asia/Seoul").format(format);
};

